// Demo Data Constants
// Centralized demo data for admin components

export const demoBookings = [
  {
    id: 1,
    name: "John Doe",
    disease: "Dental Cavity",
    description: "Severe tooth pain in the upper right molar, needs immediate attention",
    email: "john.doe@email.com",
    phone: "+1 (555) 123-4567",
    date: "2024-01-15",
    referenceId: "REF-2024-001",
    createdAt: "2024-01-10T10:30:00Z",
    status: "confirmed"
  },
  {
    id: 2,
    name: "Sarah Johnson",
    disease: "Gum Disease",
    description: "Bleeding gums and bad breath, requires periodontal treatment",
    email: "sarah.johnson@email.com",
    phone: "+1 (555) 234-5678",
    date: "2024-01-16",
    referenceId: "REF-2024-002",
    createdAt: "2024-01-11T14:20:00Z",
    status: "pending"
  },
  {
    id: 3,
    name: "Michael Brown",
    disease: "Root Canal",
    description: "Deep cavity requiring root canal treatment on tooth #14",
    email: "michael.brown@email.com",
    phone: "+1 (555) 345-6789",
    date: "2024-01-17",
    referenceId: "REF-2024-003",
    createdAt: "2024-01-12T09:15:00Z",
    status: "confirmed"
  },
  {
    id: 4,
    name: "Emily Davis",
    disease: "Teeth Whitening",
    description: "Professional teeth whitening treatment for cosmetic purposes",
    email: "emily.davis@email.com",
    phone: "+1 (555) 456-7890",
    date: "2024-01-18",
    referenceId: "REF-2024-004",
    createdAt: "2024-01-13T16:45:00Z",
    status: "completed"
  },
  {
    id: 5,
    name: "David Wilson",
    disease: "Dental Implant",
    description: "Missing tooth replacement with dental implant procedure",
    email: "david.wilson@email.com",
    phone: "+1 (555) 567-8901",
    date: "2024-01-19",
    referenceId: "REF-2024-005",
    createdAt: "2024-01-14T11:30:00Z",
    status: "confirmed"
  },
  {
    id: 6,
    name: "Lisa Anderson",
    disease: "Braces Consultation",
    description: "Initial consultation for orthodontic treatment and braces",
    email: "lisa.anderson@email.com",
    phone: "+1 (555) 678-9012",
    date: "2024-01-20",
    referenceId: "REF-2024-006",
    createdAt: "2024-01-15T13:20:00Z",
    status: "pending"
  },
  {
    id: 7,
    name: "Robert Taylor",
    disease: "Tooth Extraction",
    description: "Wisdom tooth extraction due to impaction and pain",
    email: "robert.taylor@email.com",
    phone: "+1 (555) 789-0123",
    date: "2024-01-21",
    referenceId: "REF-2024-007",
    createdAt: "2024-01-16T08:45:00Z",
    status: "confirmed"
  },
  {
    id: 8,
    name: "Jennifer Martinez",
    disease: "Dental Cleaning",
    description: "Regular dental cleaning and checkup appointment",
    email: "jennifer.martinez@email.com",
    phone: "+1 (555) 890-1234",
    date: "2024-01-22",
    referenceId: "REF-2024-008",
    createdAt: "2024-01-17T15:10:00Z",
    status: "completed"
  }
];

export const demoClinics = [
  {
    id: '1',
    name: 'Pristyn Care Clinic - Delhi',
    type: 'Primary Care',
    address: '26, National Park Rd, near Moolchand Metro station, Vikram Vihar, Lajpat Nagar IV, Lajpat Nagar, New Delhi, Delhi 110024',
    city: 'Delhi',
    phone: '+91 8065417867',
    email: 'delhi@pristyncare.com',
    status: 'active',
    doctors: 5,
    specialties: ['Ophthalmology', 'General Medicine'],
    rating: 4.5,
    totalReviews: 120
  },
  {
    id: '2',
    name: 'Pristyn Care Clinic - Bangalore',
    type: 'Specialty Care',
    address: '31, 80 Feet Rd, Hal, HAL 3rd Stage, Indiranagar, Bengaluru, Karnataka 560038',
    city: 'Bangalore',
    phone: '+91 919311583422',
    email: 'bangalore@pristyncare.com',
    status: 'active',
    doctors: 8,
    specialties: ['Ophthalmology', 'Cardiology', 'Dermatology'],
    rating: 4.7,
    totalReviews: 89
  },
  {
    id: '3',
    name: 'Pristyn Care Clinic - Pune',
    type: 'Primary Care',
    address: 'GRCW+76R, Jangali Maharaj Road Dealing Corner, Shivajinagar, Pune, Maharashtra 411004',
    city: 'Pune',
    phone: '+91 919311583422',
    email: 'pune@pristyncare.com',
    status: 'active',
    doctors: 3,
    specialties: ['Ophthalmology'],
    rating: 4.3,
    totalReviews: 45
  }
];

export const mockDoctorData = {
  name: "Dr. Rajesh Kumar",
  specialty: "General Surgery",
  qualification: "MBBS, MS (General Surgery)",
  experience: "15+ years",
  rating: 4.8,
  reviews: 234,
  consultationFee: 800,
  location: "Delhi",
  hospital: "TheLivCure Elantis",
  languages: ["English", "Hindi"],
  about: "Dr. Rajesh Kumar is a highly experienced General Surgeon with over 15 years of expertise in minimally invasive surgical procedures.",
  education: [
    "MBBS from All India Institute of Medical Sciences (AIIMS), Delhi",
    "MS in General Surgery from Post Graduate Institute (PGI), Chandigarh"
  ],
  specializations: [
    "Laparoscopic Surgery",
    "Gallbladder Surgery", 
    "Hernia Repair",
    "Appendix Surgery"
  ],
  achievements: [
    "Performed 3000+ successful surgeries",
    "Gold Medalist in MS Surgery",
    "Member of Association of Minimal Access Surgeons"
  ],
  availableSlots: [
    "10:00 AM", "11:00 AM", "2:00 PM", "3:00 PM", "4:00 PM", "5:00 PM"
  ]
};
